import { DkimService } from './dkim.service';
import { SmsCreditsService } from './sms-credits.service';
import { TrialAccountUpgradeService } from './trial-account-upgrade.service';
import { SmsCreditSubscriptionService } from '../components/sms-credit-subscription/services/sms-credit-subscription.service';
import { SmsCreditSubscriptionStateService } from '../components/sms-credit-subscription/services/sms-credit-subscription-state.service';

export const SERVICES = [
  DkimService,
  SmsCreditsService,
  TrialAccountUpgradeService,
  SmsCreditSubscriptionService,
  SmsCreditSubscriptionStateService,
];
